export const dataTablePreset = {
  datatable: {
    css: () => `
      .p-datatable {
        border-top: 1px solid var(--neutral--20);
        overflow: hidden;
      }

      .p-datatable .p-datatable-thead > tr > th {
        background: #ffffff;
        color: var(--neutral--60);
        font-weight: 700;
        font-size: 0.875rem;
        padding: 1rem 1.25rem;
      }

      .p-datatable .p-datatable-tbody > tr > td {
        padding: 1.1rem 1.25rem;
        border-bottom: 1px solid var(--neutral--20);
        font-size: 14px;
        color: var(--neutral--70);
        font-weight: 700;
        vertical-align: middle;
      }

      .p-datatable .p-datatable-tbody > tr:hover {
        background: var(--neutral--5);
      }

      .p-datatable .p-datatable-thead > tr > th:first-child,
      .p-datatable .p-datatable-tbody > tr > td:first-child {
        width: 3.25rem;
        padding-left: 1rem;
        padding-right: 0.5rem;
      }

      .p-button.census-action {
        border-radius: 6px;
        padding: 0.3rem 0.9rem;
        font-weight: 700;
        gap: 0.5rem;
        font-size: 14px;
        border: 1px solid transparent !important;
      }

      .p-button.census-action.census-action--approve,
      .p-button.census-action.census-action--approve:hover,
      .p-button.census-action.census-action--approve:active,
      .p-button.census-action.census-action--approve:focus {
        background: var(--brand--5) !important;
        border-color: var(--brand--40) !important;
        color: var(--brand--60) !important;
      }

      .p-button.census-action.census-action--approve:hover {
        background: var(--brand--10) !important;
      }

      .p-button.census-action.census-action--reject,
      .p-button.census-action.census-action--reject:hover,
      .p-button.census-action.census-action--reject:active,
      .p-button.census-action.census-action--reject:focus {
        background: #FAEAE9 !important;
        border-color: #D45450 !important;
        color: #C92924 !important;
      }

      .p-button.census-action.census-action--reject:hover {
        background: #fecaca !important;
      }

      .p-button.census-icon-button,
      .p-button.census-icon-button:hover,
      .p-button.census-icon-button:active,
      .p-button.census-icon-button:focus {
        width: 2.25rem;
        height: 2.25rem;
        padding: 0 !important;
        border-radius: 0.5rem;
        background: #ffffff !important;
        border: 1px solid var(--neutral--20) !important;
        color: var(--neutral--60) !important;
      }

      .p-button.census-icon-button:hover {
        background: var(--neutral--5) !important;
      }

      .census-actions {
        display: flex;
        gap: 0.75rem;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: nowrap;
      }
    `,
  },
};
